export const applicationSettings = {
	heading: {
		sv: "Anpassa dina val",
	},
	subHeading: {
		sv: "Här kan du skriva in namn och kortuppgifter på dina Svea Bankkort samt kreditkort.",
	},
	fullAccessUser: {
		heading: {
			sv: "Användare med full tillgång",
		},
		description: {
			sv: " De här användarna kommer ha full tillgång till bankens tjänster. Vill du lägga till fler användare kan du göra det senare i internetbanken.",
		},
	},
	cardSettings: {
		heading: {
			sv: "Kortuppgifter",
		},
		description: {
			sv: "Här fyller du i namn och kontaktuppgifter till de som ska ha ett kort. När allt är signerat och klart skickar vi korten till kortinnehavarens folkbokföringsadress. Normalt levereras de inom en vecka.",
		},
		cardDisplayName: {
			sv: "Namn på kort",
		},
		cardCompanyName: {
			sv: "Företagsnamn",
		},
		ssnFormat: {
			sv: "ÅÅÅÅMMDD-XXXX",
		},
		creditLimit: {
			sv: "Kreditgräns",
		},
		pinCodeInfo: {
			sv: "Pinkod väljs av kortinnehavaren när kortet aktiveras i internetbanken. Kortet skickas till kortinnehavarens folkbokföringsadress.",
		},
		address: {
			sv: "Adress",
		},
		formError: {
			sv: "Du måste fylla i namn och kontaktuppgifter för alla kort",
		},
		modal: {
			heading: {
				sv: "Välj namn på kortet",
			},
			description: {
				sv: "Här ser du de namnkombinationer som ryms på kortet. Välj ett alternativ.",
			},
			radioLabel: {
				sv: "Välj ett alternativ",
			},
		},
	},
	buttonText: {
		edit: {
			sv: "Ändra",
		},
		add: {
			sv: "Lägg till",
		},
		back: {
			sv: "Tillbaka",
		},
		continue: {
			sv: "Fortsätt",
		},
		getDisplayName: {
			sv: "Hämta namn",
		},
		save: {
			sv: "Spara",
		},
		changeDisplayName: {
			sv: "Ändra namn",
		},
		changeCardOwner: {
			sv: "Byt kortinnehavare",
		},
		editCard: {
			sv: "Ändra kortinnehavare",
		},
		handleCard: {
			sv: "Hantera kort",
		},
	},
};
